"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.snakeToPascal = exports.slugify = exports.setAltText = exports.objectToGetParams = exports.isTouchDevice = exports.getMinutesFromStr = exports.generateHrefFromProgramSlug = exports.convert12to24 = exports.classes = exports.chunkArray = exports.areaCodePhoneNumberMask = void 0;
exports.stringToCamelCase = stringToCamelCase;
exports.windowOpen = windowOpen;
/**
 * Creates a chunked array from the original array
 * where the chunks are determined by chunkSize
 * 
 * @param {number} chunkSize 
 * @param {array} array 
 * @returns {array} chunkedArray
 */
const chunkArray = (chunkSize, array) => {
  let chunkedArray = [];
  for (let i = 0; i <= Math.floor(array.length / chunkSize); i++) {
    if (array.slice(i * chunkSize, chunkSize * (i + 1)).length) chunkedArray.push(array.slice(i * chunkSize, chunkSize * (i + 1)));
  }
  return chunkedArray;
};

/**
 * Converts a time sting of the format "HH:MM" to
 * a string formatted as "MM MIN"
 * 
 * @param {string} runTime 
 * @returns {string} minutesStr
 */
exports.chunkArray = chunkArray;
const getMinutesFromStr = timeLenghtStr => {
  if (timeLenghtStr === '' || timeLenghtStr === undefined || timeLenghtStr === null) return '';
  const [hours, mins] = timeLenghtStr.split(':');
  const minutesStr = `${Number.parseInt(hours, 10) * 60 + Number.parseInt(mins, 10)} MIN`;
  return minutesStr;
};

/** 
 * Converts a 12h time formatted as H:MM AM/PM 
 * to a 24h time formatted as HH:MM
 * 
 * @param {string} time12h
 * @returns {string} time24h
 * 
*/
exports.getMinutesFromStr = getMinutesFromStr;
const convert12to24 = time12h => {
  const [time, modifier] = time12h.split(' ');
  let [hours, minutes] = time.split(':');
  if (hours === '12') hours = '00';
  if (modifier === 'PM') {
    hours = parseInt(hours, 10) + 12;
  }
  if (hours.length === 1) hours = `0${hours}`;
  return `${hours}:${minutes}`;
};

/**
 * Converts a string to a slug
 * 
 * convert all characters to lowercase, trim whitespace
 * replace spaces, dashes and underscores with a dash (-) 
 * remove special characters
 * 
 * @param {string} str 
 * @returns {string} 
 */
exports.convert12to24 = convert12to24;
const slugify = str => str.toLowerCase().trim().replace(/[^\w\s-]/g, '').replace(/[\s_-]+/g, '-').replace(/^-+|-+$/g, '');

/**
 * Formats a phone number input to the format
 * (xxx) xxx-xxxx
 * 
 * @param {string} value
 * @returns {string} formattedValue
 */
exports.slugify = slugify;
const areaCodePhoneNumberMask = (value = '') => {
  const strippedValue = value.replace(/\D/ig, "");
  let formattedValue = '';
  if (strippedValue.length > 0 && strippedValue.length < 3) {
    formattedValue = `(${strippedValue}`;
  }
  if (strippedValue.length >= 3 && strippedValue.length < 6) {
    formattedValue = `(${strippedValue.slice(0, 3)}) ${strippedValue.slice(3, 6)}`;
  }
  if (strippedValue.length >= 6) {
    formattedValue = `(${strippedValue.slice(0, 3)}) ${strippedValue.slice(3, 6)}-${strippedValue.slice(6)}`;
  }
  return formattedValue;
};

/** 
 * Create an HTML class list from an array or nested arrays.
 * 
 * It will exclude any value that is not a string. Nested arrays will be flattened.
*/
exports.areaCodePhoneNumberMask = areaCodePhoneNumberMask;
const classes = (list = []) => list.flat().filter(item => item && typeof item === 'string').join(' ');

/**
 * Convert and object into a GET query string
 * 
 * @param {object} object 
 * @returns {string}
 */
exports.classes = classes;
const objectToGetParams = object => {
  const params = Object.keys(object).filter(key => !!object[key]);
  if (!params.length) return '';
  return '?' + params.map(key => `${key}=${encodeURIComponent(object[key])}`).join('&');
};

/**
 * Open a new window using the window.open method
 * 
 * @param {string} url - the url to open
 * @param {number} width - the width of the new window in px
 * @param {number} height - the height of the new window in px
 * 
 * @returns {null} 
 */
exports.objectToGetParams = objectToGetParams;
function windowOpen(url, width = 650, height = 450, location = 'no', menubar = 'no', resizable = 'no') {
  const left = window.outerWidth / 2 + (window.screenX || window.screenLeft || 0) - width / 2;
  const top = window.outerHeight / 2 + (window.screenY || window.screenTop || 0) - height / 2;
  const config = {
    height,
    width,
    left,
    top,
    location,
    toolbar: 'no',
    status: 'no',
    directories: 'no',
    menubar,
    scrollbars: 'yes',
    resizable,
    centerscreen: 'yes',
    chrome: 'yes'
  };
  const shareDialog = window.open(url, 'share', Object.keys(config).map(key => `${key}=${config[key]}`).join(','));
  return shareDialog;
}

/**
* Converts a string in snake_case to PascalCase.
* 
* @param {string} str - The snake_case string to be converted.
* @returns {string} - The converted string in PascalCase.
*/
const snakeToPascal = str => {
  return str
  // Split the snake_case string into an array of words using '_' as a delimiter
  .split("_")
  // Iterate through the array of words and capitalize the first letter of each word
  .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
  // Join the capitalized words back into a single string without any delimiter (PascalCase)
  .join("");
};

/**
* Converts a space separated string to camelCase.
* 
* @param {string} str - The space separated string to be converted.
* @returns {string} - The converted string in camelCase.
*/
exports.snakeToPascal = snakeToPascal;
function stringToCamelCase(str) {
  // Split the string into words using ' ' as a delimiter
  const words = str.split(' ');
  // Convert the first word to lowercase
  const result = [words[0].toLowerCase()];
  // Convert the rest of the words to Title Case (remove spaces, first character uppercased, the rest lowercased)
  for (let i = 1; i < words.length; i++) {
    result.push(words[i].charAt(0).toUpperCase() + words[i].slice(1).toLowerCase());
  }

  // Combine the words back into a single string
  return result.join('');
}

/**
* Generates the href link for a given program item object based on its slug and type.
*
* @param {object} programItem - The program item object containing the slug and type.
*                              - Must have a __typename property that is either 'SeriesItem' or 'MovieItem', a slug property that contains the unique identifier for the program item, and have preventDetailPage set to a falsy value.
* @returns {string} - The href link for the program item, formatted as 'show/{slug}' for SeriesItems or 'movie/{slug}' for MovieItems.
*                    - An empty string is returned if programItem is undefined or does not have a valid type or slug.
*/
const generateHrefFromProgramSlug = programItem => {
  if (programItem && (programItem.__typename === 'SeriesItem' || programItem.__typename === 'MovieItem') && programItem.slug && !programItem.preventDetailPage) {
    let href = '';
    switch (programItem.__typename) {
      case 'SeriesItem':
        href = 'show/' + programItem.slug;
        break;
      case 'MovieItem':
        href = 'movie/' + programItem.slug;
        break;
      default:
        break;
    }
    return href;
  }
  return '';
};

/**
* Determines the alt text for an image associated with an object, based on the object's properties.
*
* @param {object} data - The object containing properties related to the image and alt text.
*                       - Must have an "omitAltText" property that is a boolean, an "altTextOverride" property that is a string or undefined, and an "image" property that is an array of image objects, with each object having an "alt" property that is a string or undefined.
* @returns {string} - The alt text for the image, determined based on the slide object's properties.
*                    - An empty string is returned if "omitAltText" is true, or none of the other conditions are met. 
*                    - The value of "altTextOverride" is returned if it is defined & truthy
*                    - Otherwise, the alt value associated with the image is returned if it is defined & truthy
*/
exports.generateHrefFromProgramSlug = generateHrefFromProgramSlug;
const setAltText = data => {
  var _data$image, _data$image$;
  if (data !== null && data !== void 0 && data.altTextOverride) return data.altTextOverride;
  if (data !== null && data !== void 0 && (_data$image = data.image) !== null && _data$image !== void 0 && (_data$image$ = _data$image[0]) !== null && _data$image$ !== void 0 && _data$image$.alt) return data.image[0].alt;
  return '';
};

/**
* Determines if the current device is a touch device.
* 
* @returns {boolean} - True if the current device is a touch device, false otherwise.
*/
exports.setAltText = setAltText;
const isTouchDevice = () => {
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
};
exports.isTouchDevice = isTouchDevice;